module.exports = __webpack_public_path__ + "img/7.74286ad5.jpg";